import Icon from "assets/images/settings/subscription2.svg";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button, TextView } from "../../components";
import { colors } from "../../utils";
import celebrations from "assets/images/celebrations.svg";
import bankIcon from "assets/images/bank-icon.svg";
import CheckIcon from "@mui/icons-material/Check";
import {
  useCancelSubscription,
  usePurchaseSubscription,
} from "../../services/mutations";
import { useGetAllSubcriptions } from "../../services/queries";
import { toast } from "react-toastify";
import DialogModal from "../DialogModal";
import { connectStripeAccount } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { ASSETS } from "../../utils/config";

const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  margin: 0px 2vw;
  padding: 3vw;
`;

const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  width: 80%;
  margin-top: 20px;
`;

const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;

const SubscriptionItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid ${colors.lightGrey};

  /* border-image-source: linear-gradient(
    90deg,
    #e1ff4f 0.51%,
    #42fbff 35.32%,
    #f95dfd 60.23%,
    #f7d2e8 85.99%,
    #ffc84c 96.53%
  ); */
`;

const Details = styled.div``;

const RadioButton = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isSelected }) =>
    isSelected ? colors.green : colors.white};
  border-color: ${({ isSelected }) =>
    isSelected ? colors.green : colors.lightGrey};
`;

const ButtonView = styled.div`
  display: flex;
  margin-top: 20px;
`;

export default function Subscription() {
  const [isSelected, setIsSelected] = useState(false);
  const [showUnsubModal, setShowUnsubModal] = useState(false);
  const [showBankPopup, setShowBankPopup] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const purchaseSubscription = usePurchaseSubscription();
  const cancelSubscription = useCancelSubscription();
  const { data, isLoading, refetch } = useGetAllSubcriptions();

  const subscriptionData = data?.data.results?.[0] || {};

  const nav = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);

  const status = urlParams.get("status");
  const from_referral = urlParams.get("from_referral") || false;
  const showPopup = urlParams.get("popup") || false;

  useEffect(() => {
    setShowBankPopup(showPopup);
  }, [showPopup]);

  useEffect(() => {
    if (status === "completed") {
      setShowSuccessModal(true);
      return;
    }
    if (status === "cancelled") {
      toast.error("Payment cancelled!");
      return;
    }
  }, []);

  const subscribePackage = () => {
    purchaseSubscription.mutate(
      {
        subscription_package: subscriptionData?.id,
        from_referral: from_referral,
      },
      {
        onSuccess: (res) => {
          window.open(res.data.url, "_blank");
        },
      }
    );
  };

  const unsubscribePackage = () => {
    cancelSubscription.mutate(
      {},
      {
        onSuccess: (res) => {
          refetch();
          setShowUnsubModal(false);
          toast.error("Subscription cancelled!");
        },
      }
    );
  };

  const addBankDetails = async () => {
    let res = await connectStripeAccount();
    if (res?.data) {
      window.location.href = res?.data?.url;
    }
  };

  const onPopupClose = () => {
    setShowBankPopup(false);
    urlParams.delete("popup");
    nav("/referrals");
  };

  return (
    <CenterWrapper>
      <ContentHeader>
        <HeaderIcon src={Icon} />
        <TextView variant="title">Subscription</TextView>
      </ContentHeader>
      {/* <TextView variant="subtitle">
        Introducing our revolutionary subscription service at just $1 per month
      </TextView> */}
      {/* <Content>
        {!isLoading && (
          <>
            <SubscriptionItem
              isSelected={isSelected || subscriptionData.is_active}
            >
              <Details>
                <TextView>Monthly</TextView>
                <TextView>
                  <span style={{ fontSize: 16, fontWeight: 500 }}>$1</span> /
                  month
                </TextView>
                <TextView variant="tag" style={{ fontWeight: "normal" }}>
                  Cancel anytime
                </TextView>
              </Details>
              <RadioButton
                isSelected={isSelected || subscriptionData.is_active}
                onClick={() =>
                  !subscriptionData.is_active && setIsSelected(!isSelected)
                }
              >
                <CheckIcon style={{ color: colors.white, fontSize: 14 }} />
              </RadioButton>
            </SubscriptionItem>
            {!subscriptionData.is_active && isSelected && (
              <ButtonView>
                <Button
                  onClick={subscribePackage}
                  style={{ width: 220, marginRight: 12 }}
                >
                  Subscribe Now
                </Button>
              </ButtonView>
            )}
            {subscriptionData && subscriptionData.is_active && (
              <ButtonView>
                <Button
                  onClick={() => setShowUnsubModal(true)}
                  style={{
                    width: 220,
                    marginRight: 12,
                    backgroundColor: colors.error,
                  }}
                >
                  Unsubscribe
                </Button>
              </ButtonView>
            )}
          </>
        )}
      </Content> */}

      <div
        style={{
          height: 280,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          style={{ width: "100%", height: "120px", alignSelf: "center" }}
          src={ASSETS.segmentEditor.comingSoonV2}
          alt="cs"
        />
      </div>

      <DialogModal
        open={showUnsubModal}
        onClose={() => setShowUnsubModal(false)}
        title="Cancel Subscription"
        message="All premium features will be lost when your subscription expires"
        primaryButton={"Confirm"}
        secondaryButton={"Cancel"}
        onPrimaryPress={unsubscribePackage}
        onSecondaryPress={() => setShowUnsubModal(false)}
      />

      <DialogModal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Thanks for joining"
        message="Now let's get your account set up!"
        icon={celebrations}
        primaryButton={"Get Started"}
        secondaryButton={"Not now"}
        onSecondaryPress={() => setShowSuccessModal(false)}
      />

      <DialogModal
        open={showBankPopup}
        onClose={onPopupClose}
        title="Bank Details"
        message="To complete your sign-up for the Earnings Program, you are required to provide your bank details."
        icon={bankIcon}
        primaryButton={"Add details"}
        secondaryButton={"Not now"}
        onPrimaryPress={addBankDetails}
        onSecondaryPress={onPopupClose}
      />
    </CenterWrapper>
  );
}
